import { Flex } from '@hopin-team/ui-flex';
import { Halon } from '@hopin-team/ui-halon';
import { Illustration } from '@hopin-team/ui-illustration';
import React from 'react';

import { useLocales } from '../../hooks';
import { EmptyText } from './ItemContent-styles';

export const EmptyItems = ({
  withIllustration,
}: {
  withIllustration?: boolean;
}) => {
  const { t } = useLocales('event');

  return (
    <Flex flexDirection="column" alignItems="center" mt={4}>
      {withIllustration ? (
        <Illustration name="error" />
      ) : (
        <Halon icon="calendar" color="grey-200" iconColor="grey-600" />
      )}
      <EmptyText pattern="headingTwo" mt={2}>
        {t('no-scheduled-segments-found')}
      </EmptyText>
      <EmptyText mt={2}>{t('no-scheduled-segments-found-body')}</EmptyText>
    </Flex>
  );
};
